module.exports = __webpack_public_path__ + "img/burundi.0130e07f.png";